import { useState } from "react";
import { Download } from "lucide-react";

import FusionPanel from "pages/files/image/fusion/FusionPanel";
import { getAdminFileDownloadUrl } from "lib/api/adminFiles";
import { downloadAdminFile } from "lib/utils/adminFileDownload";

export default function AdminFusionPanel({
  file,
  fileId,
  t,
  onMoveToThreePhase,
}) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState("");
  const uploadId = file?.upload_id || fileId;

  const handleOriginalDownload = async () => {
    if (!uploadId) return;

    setIsDownloading(true);
    setDownloadError("");

    try {
      const result = await downloadAdminFile(
        getAdminFileDownloadUrl(uploadId),
        file?.file_name || "",
      );

      if (!result?.success) {
        setDownloadError(result?.message || t("adminFiles.downloadError"));
      }
    } catch (error) {
      setDownloadError(error?.message || t("adminFiles.downloadError"));
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="adminFileViewer">
      <div className="adminFileViewer__toolbar">
        <button
          type="button"
          className="adminFileViewer__downloadBtn"
          onClick={handleOriginalDownload}
          disabled={isDownloading || !uploadId}
        >
          <Download size={16} aria-hidden="true" />
          {isDownloading
            ? t("adminFiles.actions.downloading")
            : t("adminFiles.originalDownload")}
        </button>
        {downloadError ? (
          <span className="adminFileViewer__error">{downloadError}</span>
        ) : null}
      </div>

      <FusionPanel
        file={file}
        t={t}
        onMoveToThreePhase={onMoveToThreePhase}
      />
    </div>
  );
}
